module.exports = __webpack_public_path__ + "static/media/item_16_2_comp.6fb6760b.png";